var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded && _vm.results)?_c('vcb-card-grid',{attrs:{"error":_vm.error,"query":_vm.query,"cards":_vm.results}}):_c('vcb-loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }